import { constants } from '../constants';

const setCouponsLoadingAction = flag => ({
  type: constants.coupons.SET_COUPONS_LOADING,
  flag,
});

const setCouponsAction = (coupons, header, footer, count) => ({
  type: constants.coupons.SET_COUPONS,
  coupons,
  header,
  footer,
  count,
});

const exportCouponsAction = (filename, filter) => ({
  type: constants.coupons.EXPORT_COUPONS,
  filename,
  filter,
});

const exportCouponsAsyncAction = (filter, filename) => ({
  type: constants.coupons.EXPORT_COUPONS_ASYNC,
  filter,
  filename,
});

const exportCouponsCodeByCodeAction = (couponId, filename) => ({
  type: constants.coupons.EXPORT_COUPONS_CODE_BY_CODE,
  couponId,
  filename,
});

const setExportIdentifierAction = identifier => ({
  type: constants.coupons.SET_COUPONS_EXPORT_IDENTIFIER,
  identifier,
});

const setPendingCouponCreationAction = pendingCouponCreation => ({
  type: constants.coupons.SET_PENDING_COUPON_CREATION,
  pendingCouponCreation,
});

const clearPendingCouponCreationAction = () => ({
  type: constants.coupons.CLEAR_PENDING_COUPON_CREATION,
});

const getCouponsAction = filter => ({
  type: constants.coupons.GET_COUPONS,
  filter,
});

const clearCouponsAction = () => ({
  type: constants.coupons.CLEAR_COUPONS,
});

const getCouponAction = id => ({
  type: constants.coupons.GET_COUPON,
  id,
});

const setCouponAction = coupon => ({
  type: constants.coupons.SET_COUPON,
  coupon,
});

const createCouponAction = (payload, history) => ({
  type: constants.coupons.CREATE_COUPON,
  payload,
  history,
});

const editCouponAction = (id, payload, history) => ({
  type: constants.coupons.EDIT_COUPON,
  id,
  payload,
  history,
});

export const couponsActions = {
  setCouponsLoadingAction,
  setCouponsAction,
  exportCouponsAction,
  exportCouponsAsyncAction,
  setPendingCouponCreationAction,
  clearPendingCouponCreationAction,
  getCouponsAction,
  clearCouponsAction,
  getCouponAction,
  setCouponAction,
  exportCouponsCodeByCodeAction,
  setExportIdentifierAction,
  createCouponAction,
  editCouponAction,
};
